export const ADD_TO_WATCHLIST = 'ADD_TO_WATCHFILE'
export const REMOVE_FROM_WATCHLIST = 'REMOVE_FROM_WATCHLIST'
